var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"title"},[_vm._v("404")]),_c('div',{staticClass:"info"},[_vm._v("提示：你请求访问的页面，暂时找不到，我们建议你返回首页官网进行浏览，谢谢！")])])
}]

export { render, staticRenderFns }